<template>
  <v-container :class="containerClass" fluid>
    <invoice-form mode="edit" :invoice="invoice.data" @cancel="onCancel">
      <template #header>
        <invoice-detail-header :invoice="invoice.data" />
      </template>
    </invoice-form>
  </v-container>
</template>
<script>
import LayoutDashboard from '@layouts/Dashboard'
import InvoiceForm from '@components/Invoice/Form'
import InvoiceDetailHeader from '@components/Invoice/DetailHeader'
export default {
  components: {
    InvoiceForm,
    InvoiceDetailHeader,
  },
  layout: LayoutDashboard,
  props: {
    invoice: {
      type: Object,
      required: true,
    },
  },
  methods: {
    onCancel() {
      window.location.href = this.$route('invoices.index')
    },
  },
}
</script>
